import {
  createRouter,
  RouteRecordRaw,
  Router,
  createWebHistory
} from "vue-router";
import type { App } from "vue";
import { useDarkMode } from "@/logics/init-dark-mode";

const routes: Array<RouteRecordRaw> = [
  // 分享裂变
  {
    path: "/sharing-fission",
    name: "SharingFission", // 大驼峰
    component: () => import("@/views/sharing-fission/index.vue")
  },
  // 学习记录
  {
    path: "/learning-history",
    name: "LearningHistoryPage",
    component: () => import("@/views/learning-history/index.vue")
  },
  {
    path: "/learning-language",
    name: "LearningLanguage",
    component: () => import("@/views/learning-language/index.vue")
  },
  // 标签匹配 V2
  {
    path: "/tag-matching",
    name: "TagMatching",
    component: () => import("@/views/tag-matching/index.vue")
  },
  // 动态中心
  {
    path: "/dynamic-centering",
    name: "DynamicCentering",
    component: () => import("@/views/dynamic-centering/index.vue"),
    meta: {
      noDark: true
    }
  },
  // VIP裂变活动
  {
    path: "/vip-fission",
    name: "VipFission",
    component: () => import("@/views/vip-fission/index.vue")
  },
  {
    path: "/language-partner-push-system",
    name: "languagePartnerPushSystem",
    component: () => import("@/views/language-partner-push-system/index.vue")
  },
  {
    path: "/credit-score",
    name: "CreditScore",
    component: () => import("@/views/credit-score/index.vue")
  },
  {
    path: "/tag-matching",
    name: "TagMatching",
    component: () => import("@/views/tag-matching/index.vue")
  },
  {
    path: "/personality-test",
    name: "PersonalityTest",
    component: () => import("@/views/personality-test/index.vue"),
    meta: {
      noDark: true
    }
  },
  {
    path: "/personality-test-result",
    name: "PersonalityTestResult",
    component: () => import("@/views/personality-test/TestResult.vue"),
    meta: {
      noDark: true
    }
  },
  // 话题广场
  {
    path: "/topic-square",
    name: "TopicSquare",
    component: () => import("@/views/topic-square/index.vue")
  },
  {
    path: "/topic-follow",
    name: "TopicFollow",
    component: () => import("@/views/topic-square/follow.vue")
  },
  //   标签匹配 v3
  {
    path: "/tag-match-v3",
    name: "TagMatchV3",
    component: () => import("@/views/tag-match-v3/index.vue"),
    meta: {
      noDark: true
    }
  },
  // 换绑验证
  {
    path: "/verification",
    name: "Verification",
    component: () =>
      import("@/views/mobile-verification/MobileVerification.vue")
  },
  // 新星计划
  {
    path: "/new-star-project",
    name: "NewStarProject",
    component: () => import("@/views/new-star-project/index.vue"),
    meta: {
      noDark: true
    }
  },
  // 年度报告
  {
    path: "/annual-report",
    name: "AnnualReport",
    component: () => import("@/views/annual-report/index.vue"),
    meta: {
      noDark: true
    }
  },
  {
    path: "/agreement",
    name: "Agreement",
    component: () => import("@/views/annual-report/Agreement.vue"),
    meta: {
      noDark: true
    }
  },
  {
    path: "/annual-report-poster",
    name: "AnnualReportPoster",
    component: () => import("@/views/annual-report-poster/index.vue"),
    meta: {
      noDark: true
    }
  },
  // 传送门
  {
    path: "/portal",
    name: "Portal",
    component: () => import("@/views/portal/index.vue"),
    meta: {
      noDark: true
    }
  },
  {
    path: "/portal-result",
    name: "PortalResult",
    component: () => import("@/views/portal/ResultPage.vue"),
    meta: {
      noDark: true
    }
  },
  {
    path: "/portal-detail",
    name: "PortalDetail",
    component: () => import("@/views/portal/PortalDetail.vue"),
    meta: {
      noDark: true
    }
  },
  {
    path: "/portal-not-found",
    name: "PortalNotFound",
    component: () => import("@/views/portal/NotFound.vue"),
    meta: {
      noDark: true
    }
  },
  {
    path: "/delete-account",
    name: "DeleteAccount",
    component: () => import("@/views/delete-account/index.vue")
  },
  {
    path: "/interaction-ranking",
    name: "InteractionRanking",
    component: () =>
      import("@/views/dynamic-centering/page/interaction-list/index.vue"),
    meta: {
      noDark: true,
      detach: true
    }
  },
  {
    path: "/sdk-user-protocol",
    name: "SdkUserProtocol",
    component: () => import("@/views/protocol/sdk-user.vue"),
    meta: {
      noDark: true
    }
  },
  {
    path: "/yuewen",
    name: "Yuewen",
    component: () => import("@/views/yuewen/index.vue")
  },
  {
    path: "/community-governance-notice",
    name: "CommunityGovernanceNotice",
    component: () => import("@/views/community-governance-notice/index.vue"),
    meta: {
      noDark: false,
      title: "社区治理公告"
    }
  },
  // 与你合拍
  {
    path: "/photo-with-you",
    name: "PhotoWithYou",
    component: () => import("@/views/photo-with-you/index.vue"),
    meta: {
      noDark: false
    },
    children: [
      {
        path: "",
        name: "PhotoWithYouHome",
        component: () => import("@/views/photo-with-you/views/Home.vue"),
        meta: {
          noDark: false
        }
      },
      {
        path: "history",
        name: "PhotoWithYouHistory",
        component: () => import("@/views/photo-with-you/views/History.vue"),
        meta: {
          noDark: false
        }
      },
      {
        path: "completed",
        name: "PhotoWithYouCompleted",
        component: () => import("@/views/photo-with-you/views/Completed.vue"),
        meta: {
          noDark: false
        }
      },
      {
        path: "invitation",
        name: "PhotoWithYouInvitation",
        component: () => import("@/views/photo-with-you/views/Invitation.vue"),
        meta: {
          noDark: false
        }
      },
      {
        path: "not-found",
        name: "PhotoWithYouNotFound",
        component: () => import("@/views/photo-with-you/views/NotFound.vue"),
        meta: {
          noDark: false
        }
      }
    ]
  },
  {
    path: "/photo-with-you-offsite",
    name: "PhotoWithYouOffsite",
    component: () => import("@/views/photo-with-you/Offsite.vue")
  },
  {
    path: "/partner-matching",
    name: "PartnerMatching",
    component: () => import("@/views/partner-matching/index.vue"),
    meta: {
      noDark: false,
      title: "语伴匹配"
    }
  },
  {
    path: "/drift-bottle",
    name: "DriftBottle",
    component: () => import("@/views/drift-bottle/index.vue"),
    meta: {
      noDark: false
    },
    children: [
      {
        path: "",
        name: "DriftBottleHome",
        component: () => import("@/views/drift-bottle/views/Home.vue"),
        meta: {
          noDark: false
        }
      },
      {
        path: "gift-store",
        name: "DriftBottleGiftStore",
        component: () => import("@/views/drift-bottle/views/GiftStore.vue"),
        meta: {
          noDark: false
        }
      }
    ]
  },
  {
    path: "/share-editor",
    name: "ShareEditor",
    component: () => import("@/views/share-editor/index.vue")
  },
  {
    path: "/subscription",
    name: "Subscription",
    component: () => import("@/views/subscription/index.vue")
  },
  {
    path: "/dynamic-center",
    name: "DynamicCenter",
    component: () => import("@/views/dynamic-center-v2/index.vue"),
    children: [
      {
        path: "interaction",
        name: "DynamicCenterInteractionRank",
        component: () =>
          import("@/views/dynamic-center-v2/views/InteractionList.vue")
      },
      {
        path: "creator",
        name: "DynamicCenterCreatorRank",
        component: () =>
          import("@/views/dynamic-center-v2/views/CreatorList.vue")
      }
    ]
  },
  {
    path: "/weekly-report",
    name: "WeeklyReport",
    component: () => import("@/views/dynamic-center-v2/weekly/index.vue")
  },
  {
    path: "/2025-annual-report",
    name: "AnnualReport2025",
    component: () => import("@/views/2025-annual-report/index.vue")
  },
  {
    path: "/2025-annual-report-screenshot",
    name: "AnnualReport2025Screenshot",
    component: () => import("@/views/2025-annual-report-poster/index.vue")
  },
  {
    path: "/2026-holi-festival",
    name: "HoliFestival2026",
    component: () => import("@/views/2026-holi-festival/index.vue"),
    meta: {
      noDark: true
    }
  },
  {
    path: "/music-festival-poster",
    name: "MusicFestivalPoster",
    component: () => import("@/views/music-festival-poster/index.vue"),
    meta: {
      noDark: true
    }
  },
  {
    path: "/creator-benefit",
    name: "CreatorBenefit",
    component: () => import("@/views/creator-benefit/index.vue"),
    meta: {
      noDark: true
    }
  }
];

let routerInstance: Router;
export const router = () => {
  if (routerInstance) {
    return routerInstance;
  }
  routerInstance = createRouter({
    history: createWebHistory("retention"),
    routes,
    scrollBehavior: () => ({ left: 0, top: 0 })
  });

  routerInstance.beforeEach((to, from, next) => {
    if (to.meta.noDark) {
      useDarkMode().disable();
    }
    next();
  });

  return routerInstance;
};

export function setupRouter(app: App<Element>) {
  app.use(router());
}

export default {
  router,
  setupRouter
};
